<template>
  <div v-show="loadStop">

    <div v-if="statusConnection && !tokenExpired && lastConnectDate">
      <p>You successfully connected to Intelligent Office at {{lastConnectDate}} UTC</p>
    </div>

    <div v-if="!statusConnection || tokenExpired">
      <div class="buttons">
        <div class="col-md-6">
          <a v-bind:href="buttonUrl" class="btn btn-secondary">
            Connect with Intelligent Office
          </a>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="!ioSyncQueued">
        <div class="buttons">
          <div class="col-md-6">
            <a href="/io/syncdata" class="btn btn-secondary">
              Manually resynch Intelligent Office data
            </a>
          </div>
        </div>
      </div>
      <div v-else>
        <p><b>You have requested resynchronisation of Intelligent Office data. Please check back soon (refresh the page) for updated results.</b></p>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "IntellifloOfficeConnectionInfo",

  data() {
    return {
      statusConnection: null,
      lastConnectDate: null,
      ioSyncQueued: null,
      tokenExpired: null,
      buttonUrl: null,
      loadStop: false
    }
  },
  methods: {
    getGetStatusConnection() {
      axios.get('/io/connection-info').then((res) => {
        this.statusConnection = res.data['status_connection'];
        this.lastConnectDate = res.data['last_connect_date'];
        this.ioSyncQueued = res.data['io_sync_queued'];
        this.tokenExpired = res.data['token_expired'];
        this.buttonUrl = res.data['button_url'];
        this.loadStop = true;
      }).catch((error) => {
        console.log('error', error)
      })
    },
  },
  created() {
    this.getGetStatusConnection()
  }
}
</script>

<style scoped>

</style>